import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function A() {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');
    const { locale } = useRouter();
    const [last, setLast] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            const target = document.querySelector('.csr-A .title-common') as HTMLElement;
            target.style.transform = 'translateY(0)';
            const target0 = document.querySelector('.csr-A .title0') as HTMLElement;
            const target1 = document.querySelector('.csr-A .title1') as HTMLElement;
            const target2 = document.querySelector('.csr-A .title2') as HTMLElement;
            const target3 = document.querySelector('.csr-A .title3') as HTMLElement;
            const target4 = document.querySelector('.csr-A .title4') as HTMLElement;
            const img0 = document.querySelector('.csr-A .img0') as HTMLElement;
            const img1 = document.querySelector('.csr-A .img1') as HTMLElement;
            const img2 = document.querySelector('.csr-A .img2') as HTMLElement;
            const img3 = document.querySelector('.csr-A .img3') as HTMLElement;
            const img4 = document.querySelector('.csr-A .img4') as HTMLElement;
            target0.style.transform = 'translateX(-50%)';
            img0.style.transform = 'scale(1.1)';
            setTimeout(() => {
                setLast(false);
                target0.style.transition = 'all .5s ease-in-out';
                target0.style.transform = 'translateX(-50%) translateY(-.75rem)';
                target0.style.opacity = '0';
                target1.style.transform = 'translateX(-50%)';
                target1.style.opacity = '1';
                img0.style.opacity = '0';
                img1.style.transform = 'scale(1.1)';
                setTimeout(() => {
                    target1.style.transition = 'all .5s ease-in-out';
                    target1.style.transform = 'translateX(-50%) translateY(-.75rem)';
                    target1.style.opacity = '0';
                    target2.style.transform = 'translateX(-50%)';
                    target2.style.opacity = '1';
                    img1.style.opacity = '0';
                    img2.style.transform = 'scale(1.1)';
                    setTimeout(() => {
                        target2.style.transition = 'all .5s ease-in-out';
                        target2.style.transform = 'translateX(-50%) translateY(-.75rem)';
                        target2.style.opacity = '0';
                        target3.style.transform = 'translateX(-50%)';
                        target3.style.opacity = '1';
                        img2.style.opacity = '0';
                        img3.style.transform = 'scale(1.1)';
                        setTimeout(() => {
                            setLast(true);
                            target3.style.transition = 'all .5s ease-in-out';
                            target3.style.transform = 'translateX(-50%) translateY(-.75rem)';
                            target3.style.opacity = '0';
                            target.style.transition = 'all .5s ease-in-out';
                            target.style.opacity = '0';
                            target4.style.transform = 'translateX(-50%)';
                            target4.style.opacity = '1';
                            img3.style.opacity = '0';
                            img4.style.transform = 'scale(1.1)';
                        }, 3000);
                    }, 3000);
                }, 3000);
            }, 3000);
        }, 500);
    }, []);

    return (
        <div className={`csr-A ${css['csr-A']}`}>
            <div className="secA">
                <div className="img-box">
                    <div className="img img0">
                        <NextImage
                            webpSrc={require('@publicLocal/corporate-social-responsibility/h5/1_4.webp')}
                            src={require('@publicLocal/corporate-social-responsibility/h5/1_4.png')}
                            alt={t('secA_title4')}
                            aria-label={t('secA_title4')}
                        />
                    </div>
                    <div className="img img1">
                        <NextImage
                            webpSrc={require('@publicLocal/corporate-social-responsibility/h5/1_1.webp')}
                            src={require('@publicLocal/corporate-social-responsibility/h5/1_1.png')}
                            alt={t('secA_title1')}
                            aria-label={t('secA_title1')}
                        />
                    </div>
                    <div className="img img2">
                        <NextImage
                            webpSrc={require('@publicLocal/corporate-social-responsibility/h5/1_2.webp')}
                            src={require('@publicLocal/corporate-social-responsibility/h5/1_2.png')}
                            alt={t('secA_title2')}
                            aria-label={t('secA_title2')}
                        />
                    </div>
                    <div className="img img3">
                        <NextImage
                            webpSrc={require('@publicLocal/corporate-social-responsibility/h5/1_3.webp')}
                            src={require('@publicLocal/corporate-social-responsibility/h5/1_3.png')}
                            alt={t('secA_title3')}
                            aria-label={t('secA_title3')}
                        />
                    </div>
                    <div className="img img4">
                        <NextImage
                            webpSrc={require('@publicLocal/corporate-social-responsibility/h5/1_4.webp')}
                            src={require('@publicLocal/corporate-social-responsibility/h5/1_4.png')}
                            alt={t('secA_title4')}
                            aria-label={t('secA_title4')}
                        />
                    </div>
                    <div className={`text-box ${last ? 'last' : ''}`}>
                        <div className="title-container">
                            <p className="title-common">{t('secA_title')}</p>
                        </div>
                        <div className="title-box">
                            <p className="title title0">{t('secA_title4')}</p>
                            <p className="title title1">{t('secA_title1')}</p>
                            <p className="title title2">{t('secA_title2')}</p>
                            <p className="title title3">{t('secA_title3')}</p>
                            <p className="title title4">{t('secA_title4')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
